<template>
    <div>
        <b-row>
            <h2>opensalud ScoreCard</h2><br>
        </b-row>
        <base-dialog v-model="healthDataGraphColor.visible" :content="$t('tests.health-data-colorwarning')" :okFn="async () => { healthDataGraphColor.visible = false }" :cancelFn="() => { back() }" :dontShowAgainCookie="healthDataGraphColor.cookie" :dontShowAgainCookieExpirationDays="90"></base-dialog>
        <b-row class="mt-4">
            <b-col cols="12" sm="12" md="12" lg="6" class="p-2">
                <b-card class="card-chart-container">
                    <h5 class="text-center mb-2">{{ $t('tests.self-evaluation-tests.title') }} - {{ $t('tests.resultsDiagram') }}</h5>
                    <self-evaluation-test-diagram></self-evaluation-test-diagram>
                </b-card>
            </b-col>
            <b-col cols="12" sm="12" md="12" lg="6" class="p-2">
                <b-card class="card-chart-container">
                    <h5 class="text-center mb-2">{{ $t('healthvariables') }}</h5>
                    <health-data-diagram></health-data-diagram>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import SelfEvaluationTestDiagram from '@/components/charts/SelfEvaluationTestDiagram.vue'
import HealthDataDiagram from '@/components/charts/HealthDataDiagram.vue'
import { BCard } from 'bootstrap-vue'
import BaseDialog from '@/components/base/BaseDialog.vue'
import TreemapChart from '@/components/charts/TreemapChart.vue'
import { OPENSALUD_SCORECARD_COLOR_DISCLAIMER_COOKIE } from '@/constants/cookies'
import { getCookie } from '@/helpers/cookies.helpers'

export default {
    components: {
        SelfEvaluationTestDiagram,
        TreemapChart,
        BaseDialog,
        BCard,
        HealthDataDiagram
    },
    data () {
        return {
            healthDataGraphColor: {
                visible: getCookie(OPENSALUD_SCORECARD_COLOR_DISCLAIMER_COOKIE) !== 'true',
                cookie: OPENSALUD_SCORECARD_COLOR_DISCLAIMER_COOKIE
            }
        }
    },
    methods: {
        back () {
            window.history.back()
        }
    }
}
</script>
<style lang="scss">
.card-chart-container {
    width: 100%;
    display: flex;
    h2{
        color: $black;
    }
    flex-direction: column;
    background-color: $white;
    border-radius: 23px !important;
    box-shadow: $custom-shadow;
    @include desktop {
        padding: 1rem 2rem;
    }
    @include desktop-sm {
        padding: 1rem 2rem;
    }
    @include tablets {
        padding: 1rem 2rem;
    }
    @include mobile {
        padding: 1rem 1rem;
        h2{
        font-size: 1.3rem;
        }
    }
    height: 100%;
    border: 0px !important;
    box-sizing: border-box;
    border-radius: 10px;
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/views/selfEvaluationTests/OpensaludScorecard.vue